import axios from "axios";
class LoginRepository {
    constructor(callback) {
        this.callback = callback;
    }

    async login(payload) {
        let url = `/api/auth/login`;
        const response = await axios({ method: 'post', url, data: payload })
            .then(response => {
                return response.data;
            })
            .catch(error => ({ error: error }));
        return response;
    }
    async signup(payload) {
        let url = `/api/auth/register`;
        const response = await axios({ method: 'post', url, data: payload })
            .then(response => {
                return response.data;
            })
            .catch(error => ({ error: error }));
        return response;
    }
    async updatePass(payload) {
        let url = `/api/auth/change-password`;
        const response = await axios({ method: 'put', url, data: payload })
            .then(response => {
                return response.data;
            })
            .catch(error => ({ error: error }));
        return response;
    }
}

export default new LoginRepository();